import type { RoleCode } from '@/types';

export const PERMISSIONS = {
  ALL: [] as RoleCode[],
  HQ_ANY: ['super_admin', 'hq_admin', 'hq_ops', 'hq_finance', 'hq_cs'] as RoleCode[],
  ACCOUNT_MANAGE: ['super_admin', 'hq_admin'] as RoleCode[],
  STORE_MANAGE: ['super_admin', 'hq_admin', 'hq_ops'] as RoleCode[],
  STORE_REVIEW: ['super_admin', 'hq_admin', 'hq_ops'] as RoleCode[],
  STORE_TIER: ['super_admin', 'hq_admin', 'hq_ops'] as RoleCode[],
  CATALOG_MANAGE: ['super_admin', 'hq_admin', 'hq_ops'] as RoleCode[],
  PRICING_TIER_MANAGE: ['super_admin', 'hq_admin', 'hq_ops'] as RoleCode[],
  DEVICE_MANAGE: ['super_admin', 'hq_admin', 'hq_ops'] as RoleCode[],
  FAULT_REVIEW: ['super_admin', 'hq_admin', 'hq_ops', 'hq_cs'] as RoleCode[],
  FINANCE_VIEW: ['super_admin', 'hq_admin', 'hq_finance'] as RoleCode[],
  WITHDRAWAL_REVIEW: ['super_admin', 'hq_admin', 'hq_finance'] as RoleCode[],
  COMMISSION_RULE: ['super_admin', 'hq_admin', 'hq_finance'] as RoleCode[],
  REFERRAL_MANAGE: ['super_admin', 'hq_admin', 'hq_ops'] as RoleCode[],
  TEMPLATE_MANAGE: ['super_admin', 'hq_admin', 'hq_ops'] as RoleCode[],
  SYSTEM_CONFIG: ['super_admin', 'hq_admin'] as RoleCode[],
  AUDIT_VIEW: ['super_admin', 'hq_admin'] as RoleCode[],
  HEALTH_VIEW: ['super_admin', 'hq_admin'] as RoleCode[],
};

export function hasAny(userRoles: RoleCode[], allowed: RoleCode[]): boolean {
  if (allowed.length === 0) return true;
  return userRoles.some((r) => allowed.includes(r));
}

export function isHqRole(role: RoleCode): boolean {
  return ['super_admin', 'hq_admin', 'hq_ops', 'hq_finance', 'hq_cs'].includes(role);
}
